module.exports = __webpack_public_path__ + "static/media/twint_app.1aa231bd.svg";